module.exports = __webpack_public_path__ + "img/ennetix-individual-network-elements-page2.2ef10cc5.png";